export default "__VITE_ASSET__dwiTU4LN__"